import { StateCollection } from './State';
import { KeyedValueBridge } from './ValueBridge';
export class EquipmentSettingsBridge extends KeyedValueBridge {
    constructor(control, controlInfo, powerState, transport, valueCallback, log) {
        super('equipmentSetting', new StateCollection(), // dummy state, not used since write-only
        control, () => [], // dummy keys, not used since write-only and driver-specific
        controlInfo, powerState, transport, valueCallback, log);
    }
    convertFromParam(value) {
        return { key: value.name, value: value.value };
    }
    // not used since write-only
    convertToParam(key, value) {
        return { name: key, value };
    }
}
